import React from "react"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "../theme-provider"
import { Button } from "./button"
import { EventCategory } from "../../lib/analytics"
import { safeTrackEvent } from "../../lib/analytics-utils"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  const handleThemeToggle = () => {
    const newTheme = theme === "light" ? "dark" : "light"
    
    // Track theme change event
    safeTrackEvent({
      category: EventCategory.Engagement,
      label: `engagement_theme_toggle_to_${newTheme}`,
      context: {
        previousTheme: theme,
        newTheme: newTheme
      }
    });
    
    setTheme(newTheme);
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleThemeToggle}
    >
      <Sun className="h-5 w-5 rotate-0 scale-100 transition-transform dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-transform dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}